<template>
    <div :class="['center-modal',{'on': show}]" v-if="modal">
        <!--<div class="mask" @click="hide"></div>-->
        <div class="mask"></div>
        <div class="content">
            <Icon type="ios-close-empty" size="48" @click.stop="close"></Icon>
            <img src="../assets/images/toast_prompt_pic.png" alt="icon" v-if="icon===1">
            <img src="../assets/images/toast_certified_pic.png" alt="icon" v-if="icon===2">
            <img src="../assets/images/toast_success.svg" alt="icon" v-if="icon===3">
            <p v-html="content"></p>
            <div class="fot-btn">
                <button type="button" v-show="btn1Show" class="btn" @click.stop="submit">{{okText}}</button>
                <button type="button" v-show="btn2Show" class="btn-login" @click.stop="submit2">{{okText2}}</button>
            </div>
            <!--<button type="button" v-show="btn1Show" :class="['btn', marginLeft ? 'marginLeft' : '']" @click.stop="submit">{{okText}}</button>-->
        </div>
    </div>
</template>

<script>
    import {Icon} from 'view-design'

    export default {
        name: "Modal",
        components: {Icon},
        data() {
            return {
                modal: false,
                show: false,
                icon: 1,
                content: '',
                okText: '确认',
                okText2: '确认',
                callBack: null,
                callBack2: null,
                callBack3: null,
                btn1Show: true,
                btn2Show: false,
                marginLeft: 0
            }
        },
        methods: {
            showModal(op) {
                this.modal = true
                setTimeout(() => {
                    this.show = true
                }, 100)
                this.icon = op.icon || 1
                this.okText = op.okText
                this.okText2 = op.okText2
                this.content = op.content
                this.btn1Show = op.btn1Show || true
                this.btn2Show = op.btn2Show || false
                if (op.ok) {
                    this.callBack = op.ok
                }
                if (op.ok2) {
                    this.marginLeft = 37
                    this.callBack2 = op.ok2
                }
                if (op.close) {
                    this.callBack3 = op.close
                }
            },
            hide() {
                this.show = false
                this.modal = false
            },
            submit() {
                if (typeof this.callBack === 'function') {
                    this.callBack()
                    this.callBack = null
                }
                this.hide()
            },
            submit2() {
                if (typeof this.callBack2 === 'function') {
                    this.callBack2()
                    this.callBack2 = null
                }
                this.hide()
            },
            close() {
                if (typeof this.callBack3 === 'function') {
                    this.callBack3()
                    this.callBack3 = null
                }
                this.hide()
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/stylesheets/Mixins";
    .center-modal {
        .btn-login {
            color: $main-color;
            border: 1px solid $main-color;
            border-radius: 3px;
            margin-top: 50px;
            margin-left: 20px;
            width: 160px;
            font-size: 16px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            transition: box-shadow .3s;
            cursor: pointer;
        }
        .marginLeft {
            margin-left: 37px;
        }
        .mask, .content {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1000;
            opacity: 0;
            transition: opacity .3s ease-in-out;
        }
        &.on {
            .mask, .content {
                opacity: 1;
            }
        }
        .mask {
            top: 0;
            height: 100%;
            background-color: rgba(0, 0, 0, .8);
        }
        .content {
            top: 50%;
            width: 480px;
            height: 355px;
            margin: 0 auto;
            background-color: #fff;
            text-align: center;
            @include radius(5px);
            @include prefix-property(transform, translateY(-50%));
            img {
                margin-top: 60px;
                width: 80px;
            }
            p {
                padding: 15px 30px 0;
                font-size: 20px;
                line-height: 30px;
            }
            .fot-btn {
                @include flex-box;
                @include pack-center
            }
            button {
                margin-top: 40px;
                width: 160px;
            }
            .ivu-icon-ios-close-empty {
                position: absolute;
                top: 10px;
                right: 20px;
                color: #c9c9c9;
                &:hover {
                    cursor: pointer;
                }
            }
        }
    }
</style>
